import { useMemo } from 'react';
import React from 'react';
import { UseSpinnerProps } from '../types/spinner-types';

export const useSpinner = ({ size, color, style = {} }: UseSpinnerProps) => {

  const sizes = useMemo(() => ({
    small: '16px',
    medium: '32px',
    large: '48px'
  }), []);

  const spinnerStyle: React.CSSProperties = useMemo(() => ({
    width: sizes[size],
    height: sizes[size],
    border: `3px solid #e5e7eb`,
    borderTop: `3px solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    display: 'none', // Hidden by default
    ...style
  }), [size, color, style, sizes]);

  return { spinnerStyle };
};

